import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 8 30"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.475 1.978c-.013-.522-.282-.747-.746-.814C5.813 1.032 4.762 1 4.142 1s-1.474.032-2.39.164c-.464.067-.732.292-.746.814-.045 1.792.166 5.08.339 6.415.073.562.193.99.318 1.334.227.618.176 1.23.268 1.83.585 3.785.48 10.704.889 14.615.228 2.187.723 3.284 1.296 3.136.539-.14.778-1.368 1.007-3.547.386-3.666 1.026-11.938 1.29-14.217.078-.678.212-1.212.489-2.048.098-.298.177-.66.235-1.102.173-1.335.383-4.623.338-6.415z"
    />
  </svg>
);
export default SvgNormal;
